import { StoreApi } from 'zustand';
import { GmailAgentSlice } from './types';
import {
  getGmailConnectionStatus,
  connectGmailAccount,
  disconnectGmailAccount,
  fetchGmailEmails,
  sendGmailEmail,
} from 'api/api';
import {
  GmailConnectionStatusRequest,
  GmailConnectionStatusResponse,
  ConnectGmailAccountRequest,
  ConnectGmailAccountResponse,
  DisconnectGmailAccountRequest,
  DisconnectGmailAccountResponse,
  FetchGmailEmailsRequest,
  FetchGmailEmailsResponse,
  SendGmailEmailRequest,
  SendGmailEmailResponse,
} from 'api-types';

export const createGmailAgentSlice = (
  set: StoreApi<GmailAgentSlice>['setState'],
  get: StoreApi<GmailAgentSlice>['getState']
): GmailAgentSlice => ({
  getGmailConnectionStatus: async (
    req: GmailConnectionStatusRequest = {}
  ): Promise<GmailConnectionStatusResponse> => {
    return await getGmailConnectionStatus(req);
  },
  connectGmailAccount: async (
    req: ConnectGmailAccountRequest
  ): Promise<ConnectGmailAccountResponse> => {
    return await connectGmailAccount(req);
  },
  disconnectGmailAccount: async (
    req: DisconnectGmailAccountRequest = {}
  ): Promise<DisconnectGmailAccountResponse> => {
    return await disconnectGmailAccount(req);
  },
  fetchGmailEmails: async (
    req: FetchGmailEmailsRequest = {}
  ): Promise<FetchGmailEmailsResponse> => {
    return await fetchGmailEmails(req);
  },
  sendGmailEmail: async (
    req: SendGmailEmailRequest
  ): Promise<SendGmailEmailResponse> => {
    return await sendGmailEmail(req);
  },
});